export default __webpack_public_path__ + "static/media/ic-fruit-kiwifruit.385fc34f.svg";